export const homeFilterHeaders = {
  all: 'All sites',
  mySites: 'My sites',
  depot: 'Depot',
  site: 'Site',
  customer: 'Customer'
};
